export * from './lib/auth.module';

export * from './lib/login-dumb/login-dumb.component';
